import React, { useState } from 'react';
import axios from "axios";

export const Dashboard = (props)=>{
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [content, setContent] = useState("")
    const addPost = ()=>{
        const title = document.getElementById("floatingName").value
        const slug = document.getElementById("floatingSlug").value
        const content = document.getElementById("floatingContent").value
        var option = {
          method: 'POST',
          url: 'https://karlson.herokuapp.com/api/post/',
          headers: {
            "Content-type": "application/json; charset=UTF-8"
            },
          data: JSON.stringify({
            "userid": email,
            "pass": password,
            "title": title,
            "slug": slug, 
            "content": content
            })

        };
        axios
          .request(option)
          .then(function(response) {
            alert("Successfully Posted!")
          })
          .catch(function(err) {
            alert(err)
          });
    }
    
    return (
        <div className = "container">
        <h1 className="my-3 text-center">Hi, Eklavya</h1>
        {/**/}
        <div className="form-floating mb-3">
        <input type="emailid" value = {email} onChange = {(e)=>{setEmail(e.target.value)}} name = "emailid" className="form-control" id="floatingEmail" placeholder="EmailID"/>
        <label htmlFor="floatingName">Email</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="password" value={password} onChange = {(e)=>{setPassword(e.target.value)}} name = "password" className="form-control" id="floatingPass" placeholder="Password"/>
        <label htmlFor="floatingSlug">Password</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="text" value = {title} onChange = {(e)=>{setTitle(e.target.value)}} name = "title" className="form-control" id="floatingName" placeholder="Name"/>
        <label htmlFor="floatingName">Title</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="text" value={slug} onChange = {(e)=>{setSlug(e.target.value)}} name = "slug" className="form-control" id="floatingSlug" placeholder="Slug"/>
        <label htmlFor="floatingSlug">Slug</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <textarea type="text" value={content} onChange = {(e)=>{setContent(e.target.value)}} name = "content" style={{height: "1000px"}} className="form-control" id="floatingContent" placeholder="Content"></textarea>
        <label htmlFor="floatingContent">Content</label>
        </div>
        <button className="float-left sbtn atom-btn green-btn" onClick={addPost} >Post</button>
        </div>
)}